import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "star"]
  static values = {
    rating: { type: Number, default: 0 }
  }

  connect() {
    console.log("Rating controller connected")
    this.updateStars()
  }

  select(event) {
    const rating = parseInt(event.currentTarget.dataset.rating)
    this.ratingValue = rating
    this.updateStars()
  }

  updateStars() {
    console.log("Updating stars")
    this.starTargets.forEach((star, index) => {
      const rating = index + 1
      console.log(`Star ${rating} - ${this.ratingValue}`)
      if (rating <= this.ratingValue) {
        star.classList.add("text-warning")
        star.classList.remove("text-muted")
      } else {
        star.classList.add("text-muted")
        star.classList.remove("text-warning")
      }
    })
  }

  ratingValueChanged() {
    this.inputTarget.value = this.ratingValue
  }
}
